import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {
  AccordionDl,
  AccordionDt,
  AccordionDd,
  ButtonAccordion,
  WrapperTitle,
  IconButton
} from './style';
import { ArrowLeft } from '../../../../assets/images/index';

/**
 * Based on https://www.w3.org/TR/wai-aria-practices/examples/accordion/accordion.html
 */

class Accordion extends Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.state = { active: false };
    document.addEventListener('click', this.handleClickOutside);
  }

  onClick() {
    const { active } = this.state;
    this.setState({ active: !active });
  }

  handleKeyPress(e) {
    if (e.key === 'Enter' || e.key === 'Space') {
      this.onClick();
    }
  }

  handleClickOutside(e) {
    const el = ReactDOM.findDOMNode(this.accordion);
    const isInside = el.contains(e.target) || el === e.target;
    if (!isInside) {
      this.setState({ active: false });
    }
  }

  render() {
    const {
      className,
      title,
      mainId,
      secondaryId,
      level,
      children
    } = this.props;

    return (
      <AccordionDl
        className={className}
        role="presentation"
        ref={reference => {
          this.accordion = reference;
        }}
      >
        <AccordionDt role="heading" aria-level={level}>
          <ButtonAccordion
            aria-expanded="true"
            aria-controls={`${mainId}-${level}`}
            id={secondaryId}
            active={this.state.active}
            onClick={this.onClick}
          >
            <IconButton
              svg={ArrowLeft}
              size="s"
              color="red"
              active={this.state.active}
            />
            <WrapperTitle active={this.state.active}>{title}</WrapperTitle>
          </ButtonAccordion>
        </AccordionDt>
        <AccordionDd
          id={`${mainId}-${level}`}
          active={this.state.active}
          role="region"
          aria-labelledby={secondaryId}
          aria-hidden={!this.state.active}
        >
          <div>{children}</div>
        </AccordionDd>
      </AccordionDl>
    );
  }
}

Accordion.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  mainId: PropTypes.string,
  secondaryId: PropTypes.string,
  children: PropTypes.node
};

export default Accordion;
